import axios from 'axios';

const PREFIJO="/api/OrdTr/";

export default {
    consultar(datos) {
        const dto={dt1:datos.orden,ndt1:datos.agencia ? datos.agencia.id : null};
        return axios.post(`${PREFIJO}VmSlOrT`,dto);
    },
    consultarApp(datos) {
        const dto={dt1:datos.orden,dt2:datos.taller,dt3:datos.sucursal,dt4:datos.vin};
        return axios.post(`${PREFIJO}VmSlOTI`,dto);
    }
};
